import styles from './Home.module.css';

export function Home() {
    return (
        <div className={styles.screen}>
            <div>
                <img src="/logo.svg" alt="Atemoya Logo" className={styles.logo} />
            </div>
            <div className={styles.newLabel}>
                REACT
            </div>
        </div>
    );
}
